import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=cb06fab4&scoped=true"
import script from "./AppTemplate.vue?vue&type=script&lang=js"
export * from "./AppTemplate.vue?vue&type=script&lang=js"
import style0 from "./AppTemplate.vue?vue&type=style&index=0&id=cb06fab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb06fab4",
  null
  
)

export default component.exports